import { Box, Typography } from '@mui/material';

/**
 * Opción de autocompletar en dos líneas, como los buscadores de Finanzas:
 * el nombre en negrita y el detalle (código, unidad, descripción) en `caption`.
 * Se usa como `renderOption={renderTwoLineOption}` con opciones `{ value, label, secondary }`.
 * @param {Object} props Props que MUI entrega para el `<li>` de la opción.
 * @param {{label: string, secondary?: string}} option Opción a mostrar.
 * @returns {JSX.Element}
 */
const renderTwoLineOption = (props, option) => {
  const { key, ...optionProps } = props;
  return (
    <Box
      component="li"
      key={key}
      {...optionProps}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start !important',
        gap: 0.25,
        py: 0.75,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
        {option.label}
      </Typography>
      {option.secondary && (
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.2 }}>
          {option.secondary}
        </Typography>
      )}
    </Box>
  );
};

export default renderTwoLineOption;
